var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { findEdgeLayer, findNodeByDiagramId, collectEditableNodes } from './editor/collect';
import { getDiagramState, setDiagramState } from './helpers';
import { getActiveDiagram } from './theme';
var ECU_W = 96;
/** Distance from ECU card top to bus midline (matches createCanEcuNode tap). */
export var CAN_BUS_TAP = 18;
export function canBusHopPoints(from, to, busY) {
    var ax = from.x + ECU_W / 2;
    var ay = from.y;
    var bx = to.x + ECU_W / 2;
    var by = to.y;
    // Tap up to bus, ride the rail, tap down into the peer
    return [ax, ay, ax, busY, bx, busY, bx, by];
}
function listCanEcus(root) {
    return collectEditableNodes(root)
        .filter(function (n) { var _a; return (_a = n.metadata) === null || _a === void 0 ? void 0 : _a.diagramId; })
        .sort(function (a, b) { return a.x - b.x || a.y - b.y; });
}
function inferBusY(ecus, fallback) {
    if (fallback === void 0) { fallback = 72; }
    if (ecus.length === 0)
        return fallback;
    // ECUs sit at busY + CAN_BUS_TAP
    var ys = ecus.map(function (e) { return e.y - CAN_BUS_TAP; });
    var avg = ys.reduce(function (s, y) { return s + y; }, 0) / ys.length;
    return avg;
}
function adjacentHops(ecus) {
    var hops = [];
    for (var i = 0; i < ecus.length - 1; i++) {
        var a = String(ecus[i].metadata.diagramId);
        var b = String(ecus[i + 1].metadata.diagramId);
        hops.push({ from: a, to: b });
        hops.push({ from: b, to: a });
    }
    return hops;
}
/**
 * Ensure an edge layer exists with bus-rail hop polylines for the given hops
 * (or all adjacent ECU pairs when hops omitted — for ambient bus traffic).
 */
export function ensureCanNetworkFlowEdges(app, root, hops) {
    var e_1, _a, e_2, _b;
    var _c, _d;
    if (((_c = root.metadata) === null || _c === void 0 ? void 0 : _c.diagramType) !== 'canNetwork') {
        return findEdgeLayer(root);
    }
    var ecus = listCanEcus(root);
    var state = getDiagramState(root);
    var busY = typeof state.canBusY === 'number' ? state.canBusY : inferBusY(ecus);
    setDiagramState(root, { canBusY: busY });
    var edgeLayer = findEdgeLayer(root);
    if (!edgeLayer) {
        edgeLayer = app.group({ zIndex: -5, listening: false });
        edgeLayer.metadata.diagramEdgeLayer = true;
        edgeLayer.metadata.canFlowEdgeLayer = true;
        // Keep under ECU cards
        root.add(edgeLayer);
    }
    try {
        for (var _e = __values(__spreadArray([], __read(edgeLayer.children), false)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var child = _f.value;
            if ((_d = child.metadata) === null || _d === void 0 ? void 0 : _d.canFlowEdge) {
                edgeLayer.remove(child);
                child.destroy();
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var needed = hops && hops.length > 0
        ? hops
        : adjacentHops(ecus);
    var seen = new Set();
    var stroke = getActiveDiagram().canBus;
    var sw = Math.max(1.5, getActiveDiagram().stroke.edgeThin);
    try {
        for (var needed_1 = __values(needed), needed_1_1 = needed_1.next(); !needed_1_1.done; needed_1_1 = needed_1.next()) {
            var hop = needed_1_1.value;
            var key = "".concat(hop.from, "->").concat(hop.to);
            if (seen.has(key))
                continue;
            seen.add(key);
            var from = findNodeByDiagramId(root, hop.from);
            var to = findNodeByDiagramId(root, hop.to);
            if (!from || !to)
                continue;
            var points = canBusHopPoints(from, to, busY);
            var g = app.group({ listening: false });
            g.add(app.polyline({
                points: points,
                fill: null,
                stroke: stroke,
                strokeWidth: sw,
                opacity: 0.35,
                lineJoin: 'round',
                lineCap: 'round',
                listening: false,
                metadata: { edgeStrokePoly: true },
            }));
            g.metadata.canFlowEdge = true;
            g.metadata.edgeFrom = hop.from;
            g.metadata.edgeTo = hop.to;
            g.metadata.edgeId = "can_".concat(hop.from, "_").concat(hop.to);
            g.metadata.edgePoints = points.slice();
            g.metadata.edgeStroke = stroke;
            g.metadata.edgeStrokeWidth = sw;
            g.metadata.edgeArrowEnd = 'none';
            g.metadata.edgeArrowStart = 'none';
            g.metadata.edgeStyle = 'orthogonal';
            edgeLayer.add(g);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (needed_1_1 && !needed_1_1.done && (_b = needed_1.return)) _b.call(needed_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return edgeLayer;
}
